'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    border-collapse: collapse;\n    tr{\n        transition: all .3s;\n        &:hover > td {\n            background: #e6f7ff;\n        }\n        & > td,& > th{\n            padding: 16px 16px;\n            word-break: normal;\n        }\n        & >td{\n            border-bottom: 1px solid #e8e8e8;\n        }\n    }\n'], ['\n    width: 100%;\n    border-collapse: collapse;\n    tr{\n        transition: all .3s;\n        &:hover > td {\n            background: #e6f7ff;\n        }\n        & > td,& > th{\n            padding: 16px 16px;\n            word-break: normal;\n        }\n        & >td{\n            border-bottom: 1px solid #e8e8e8;\n        }\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    &::before {\n        content: ', ';\n        color: #f5222d;\n        margin-right: 4px;\n    }\n'], ['\n    &::before {\n        content: ', ';\n        color: #f5222d;\n        margin-right: 4px;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    &> tr > th {\n        background: #fafafa;\n        text-align: left;\n        color: rgba(0, 0, 0, 0.85);\n        font-weight: 500;\n        border-bottom: 1px solid #e8e8e8;\n    }\n'], ['\n    &> tr > th {\n        background: #fafafa;\n        text-align: left;\n        color: rgba(0, 0, 0, 0.85);\n        font-weight: 500;\n        border-bottom: 1px solid #e8e8e8;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFinalForm = require('react-final-form');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _MatrixRow = require('./MatrixRow');

var _MatrixRow2 = _interopRequireDefault(_MatrixRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Table = _styledComponents2.default.table(_templateObject);

var Label = _styledComponents2.default.p(_templateObject2, function (_ref) {
    var required = _ref.required;
    return required ? '"*"' : null;
});
var Thead = _styledComponents2.default.thead(_templateObject3);

var Matrix = function (_Component) {
    _inherits(Matrix, _Component);

    function Matrix() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, Matrix);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Matrix.__proto__ || Object.getPrototypeOf(Matrix)).call.apply(_ref2, [this].concat(args))), _this), _this.validate = function (value) {
            return !value && _this.props.required ? 'required' : undefined;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Matrix, [{
        key: 'renderHeader',
        value: function renderHeader() {
            var _props = this.props,
                scale = _props.scale,
                language = _props.language;


            return _react2.default.createElement(
                Thead,
                null,
                _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('th', null),
                    scale.map(function (item, index) {
                        return _react2.default.createElement(
                            'th',
                            { key: 'th-' + index },
                            (0, _experiumPlayerHelpers.getText)(item, language)
                        );
                    })
                )
            );
        }
    }, {
        key: 'renderRows',
        value: function renderRows() {
            var _this2 = this;

            var _props2 = this.props,
                rows = _props2.item.matrix.rows,
                scale = _props2.scale,
                language = _props2.language,
                type = _props2.type,
                viewMode = _props2.viewMode;


            return _react2.default.createElement(
                'tbody',
                null,
                rows.map(function (row, index) {
                    return _react2.default.createElement(
                        'tr',
                        { key: 'row-' + index },
                        _react2.default.createElement(_reactFinalForm.Field, {
                            name: row.id,
                            component: _MatrixRow2.default,
                            scale: scale,
                            row: row,
                            language: language,
                            validate: _this2.validate,
                            viewMode: viewMode,
                            type: type })
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                item = _props3.item,
                language = _props3.language,
                required = _props3.required;


            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    Label,
                    { required: required },
                    (0, _experiumPlayerHelpers.getText)(item, language)
                ),
                _react2.default.createElement(
                    Table,
                    null,
                    this.renderHeader(),
                    this.renderRows()
                )
            );
        }
    }]);

    return Matrix;
}(_react.Component);

Matrix.propTypes = {
    scale: _propTypes2.default.array,
    language: _propTypes2.default.string,
    item: _propTypes2.default.object,
    input: _propTypes2.default.object,
    required: _propTypes2.default.bool,
    viewMode: _propTypes2.default.bool,
    type: _propTypes2.default.string
};
exports.default = Matrix;